"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.71573,0H2.28432a.56125.56125,0,0,0-.63366.63628V20.14965a.56126.56126,0,0,0,.63366.63633H8.64374l3.19233,3.15032a.24032.24032,0,0,0,.32594,0L15.35557,20.786h6.36016a.56125.56125,0,0,0,.63361-.63633V.63628A.56123.56123,0,0,0,21.71573,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.99873,12.50744l-1.6033-1.60668-1.802,1.81337,1.608,1.61133a2.86569,2.86569,0,0,0,.68775,2.94655,2.76316,2.76316,0,0,0,3.09091.61367.3198.3198,0,0,0,.09656-.52392l-1.16638-1.12763v-.99391h.98942l1.12289,1.17155a.31712.31712,0,0,0,.52172-.0969,2.84938,2.84938,0,0,0-3.54558-3.80743Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.28746,8.399l1.60025,1.60355,1.80193-1.8133L10.08475,6.581A2.86629,2.86629,0,0,0,9.397,3.63448a2.76364,2.76364,0,0,0-3.09092-.61373.3198.3198,0,0,0-.09655.52392L7.37591,4.6723v.99429H6.3865L5.2636,4.49466a.317.317,0,0,0-.52172.09728A2.84923,2.84923,0,0,0,8.28746,8.399Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.09746,14.32515a2.864,2.864,0,0,1-.67687,2.94807,2.821,2.821,0,0,1-3.1145.61246.31979.31979,0,0,1-.09655-.52392l1.16669-1.12763v-.99359H6.3865L5.2636,16.41177a.31712.31712,0,0,1-.52172-.0969A2.79188,2.79188,0,0,1,5.353,13.21092a2.83827,2.83827,0,0,1,2.93417-.69065L14.18873,6.5816a2.862,2.862,0,0,1,.67687-2.94712,2.81926,2.81926,0,0,1,3.1145-.61373.31843.31843,0,0,1,.18872.236.32174.32174,0,0,1-.09216.28794L16.91,4.6723v.99365h.98973l1.12289-1.17129a.317.317,0,0,1,.52172.09728,2.7919,2.7919,0,0,1-.61109,3.104,2.83632,2.83632,0,0,1-2.93417.69033Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;